import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} viewBox='0 0 643 512' onClick={onClick} width={size} height={size} className={className}>
      <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g fill={fillColor} fillRule='nonzero'>
          <path d='M0,0 L0,142 L643,142 L643,0 L0,0 Z M605,105 L37,105 L37,38 L605,38 L605,105 Z' />
          <path d='M0,185 L0,327 L643,327 L643,185 L0,185 Z M605,290 L37,290 L37,223 L605,223 L605,290 Z' />
          <path d='M0,512 L390,512 L390,370 L0,370 L0,512 Z M38,408 L352,408 L352,475 L38,475 L38,408 Z' />
          <polygon
            points='558.759 421 518.837 421 435 421 435 460.922 518.837 460.922
          558.759 460.922 642.595 460.922 642.595 421'
          />
        </g>
      </g>
    </svg>
  );
});

export default React.memo(Icon);
